import { isEmpty, isNil, omitBy } from 'lodash';

import { formatPhoneNumber } from 'util/formatter';

export const springConfig = key => {
  switch (key) {
    case 'bgOpacity':
      return { duration: 300 };
    default:
      return { mass: 4, friction: 44, tension: 180, duration: 300 };
  }
};

export const formatEmployeeWithholdingPayload = (fieldValues, parameters) => {
  const keys = parameters.reduce((memo, param) => {
    memo[param.name] = true;
    return memo;
  }, {});

  const validateValue = (value, key) =>
    isNil(value) || isEmpty(value) || !keys[key];

  return Object.keys(omitBy(fieldValues, validateValue)).map(key => ({
    name: key,
    value: fieldValues[key],
  }));
};

export const MERGE_USER_REQUEST_MATCHED_ON = {
  PHONE: 'phone',
  EMAIL: 'email',
  PHONE_AND_EMAIL: 'phone_and_email',
};

export const getContactInfo = (
  phone,
  email,
  fullName,
  merge_user_request_matched_on
) => {
  let contact;
  if (
    (phone && !email) ||
    (phone &&
      merge_user_request_matched_on &&
      merge_user_request_matched_on === MERGE_USER_REQUEST_MATCHED_ON.PHONE)
  ) {
    // only phone entered (no email) OR
    // phone and email AND merge request matched on phone
    contact = formatPhoneNumber(phone);
  } else if (
    email ||
    (merge_user_request_matched_on &&
      merge_user_request_matched_on !== MERGE_USER_REQUEST_MATCHED_ON.PHONE)
  ) {
    // email is given OR
    // merge request matched on either phone_and_email or email
    contact = email;
  } else {
    // either email or phone should always be present, but adding this case as an extra precaution
    contact = fullName;
  }

  return contact;
};
